export const DEFAULT_APPOINTMENT_DURATION_HOURS = 5;

export const localDateTimeInputValue = (date: Date) => {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 16);
};

export const defaultAppointmentEnd = (startValue: string) => {
  const start = new Date(startValue);
  if (Number.isNaN(start.getTime())) return "";
  return localDateTimeInputValue(new Date(start.getTime() + DEFAULT_APPOINTMENT_DURATION_HOURS * 3_600_000));
};
